"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.calculateNetworkSpeed = void 0;

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

// Calculate network speed
var calculateNetworkSpeed = function calculateNetworkSpeed() {
  // Check performance support
  if (performance === undefined) {
    console.warn("SpeedTestJob Calculate Load Times: performance NOT supported");
    return null;
  } // Get a list of "resource" performance entries


  var resources = performance.getEntriesByType("resource");

  if (resources === undefined || resources.length <= 0) {
    console.warn("SpeedTestJob Calculate Load Times: there are NO `resource` performance records");
    return null;
  }

  var samples = [];

  var _iterator = _createForOfIteratorHelper(resources),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var res = _step.value;

      if (res.name.endsWith(".ts") && res.responseEnd && res.responseStart && res.transferSize) {
        var time = (res.responseEnd - res.requestStart) / 1000;
        var bytes = res.transferSize;
        samples.push({
          bytes: bytes,
          time: time,
          bps: bytes / time
        }); //totalBytes += bytes
        //totalTime += time
      }
    } // sort samples by bps

  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  samples = samples.sort(function (a, b) {
    return a.bps - b.bps;
  }); // throw out top and bottom 10%

  samples = samples.slice(Math.floor(samples.length / 10), Math.floor(9 * samples.length / 10)); // calculate average

  var totalBytes = samples.reduce(function (sum, sample) {
    return sum + sample.bytes;
  }, 0);
  var totalTime = samples.reduce(function (sum, sample) {
    return sum + sample.time;
  }, 0); // protect against divide by zero

  if (totalBytes === 0 || totalTime === 0) {
    return null;
  }

  var mbps = totalBytes / totalTime / 1000 / 1000 * 8;
  console.log("SpeedTestJob Calculate Load Times:", "bytes", totalBytes, "time", totalTime, "Mbps", mbps);
  return mbps;
};

exports.calculateNetworkSpeed = calculateNetworkSpeed;